export default {
  "content": "<path d=\"M9.704 3.147a.688.688 0 00-.532-.138.71.71 0 00-.47.298l-3.394 4.86-2.159-1.822a.692.692 0 00-.995.128.785.785 0 00.1 1.053l2.74 2.312a.697.697 0 001.024-.142l3.84-5.492a.787.787 0 00-.154-1.057z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};